export default __webpack_public_path__ + "static/favicon-3c165be7d74b0e86be265b49602ca7e8.ico";